module.exports = __webpack_public_path__ + "src/assets/cs.49a63bfd.png";